import React from 'react';
import './TextCaption.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TextCaption = ({ title, subtitle, paragraph, bulletPoints, buttonLink, buttonName, numbered, version = 0 }) => {
  const { t } = useTranslation();

  var paddingTop = "0rem";
  var marginleft = "15%";

  if (version === 2) {
    paddingTop = "1rem";
    marginleft = "10%";
  }


  // Function to check if the link is internal
  const isInternalLink = link => link.startsWith('/');

  // Function to check if the link is a PDF
  const isPDFLink = link => link.endsWith('.pdf');

  // Function to render bullet points with sub-bullet points
  const renderBulletPoints = (points) => {
    return points.map((point, index) => {
      // Check if point is an object with text and subBulletPoints
      if (typeof point === 'object' && point.text) {
        return (
          <li key={index}>
            {t(point.text)}
            {point.subBulletPoints && point.subBulletPoints.length > 0 && (
              <ul className={`sub-bullet-list ${numbered ? 'sub-numbered' : 'sub-bullet'}`}>
                {point.subBulletPoints.map((subPoint, subIndex) => (
                  <li key={subIndex}>
                    {t(subPoint)}
                  </li>
                ))}
              </ul>
            )}
          </li>
        );
      } else {
        // Handle simple string bullet points
        return (
          <li key={index}>
            {t(point)}
          </li>
        );
      }
    });
  };

  return (
    <div className="text-caption-header" style={{ marginleft: marginleft }}>
      {title && <h2 className="text-caption-title" style={{ color: '#28588F', paddingTop: paddingTop }}>{t(title)}</h2>}
      {subtitle && <p className="text-caption-subtitle">{t(subtitle)}</p>}
      {paragraph && <p className="text-caption-paragraph">{t(paragraph)}</p>}
      {bulletPoints && (
        <ul className={`bullet-point-list text-caption-bullets ${numbered ? 'numbered' : 'bullet'}`}>
          {renderBulletPoints(bulletPoints)}
        </ul>
      )}
      {buttonName && buttonLink && (
        isInternalLink(buttonLink) ? (
          <Link to={buttonLink} className="ImageText-button">
            {t(buttonName)}
          </Link>
        ) : (
          isPDFLink(buttonLink) ? (
            <a
              href={buttonLink}
              className="ImageText-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t(buttonName)}
            </a>
          ) : (
            <a
              href={buttonLink}
              className="ImageText-button"
            >
              {t(buttonName)}
            </a>
          )
        )
      )}
    </div>
  );
};

export default TextCaption;